<div class="flex justify-between p-5 mt-6 mx-4 sm:mx-6 lg:mx-8 rounded shadow" [class.bg-blue-100]="severity == 'info'"
    [class.bg-green-100]="severity == 'success'" [class.bg-red-100]="severity == 'error'"
    [class.bg-yellow-100]="severity == 'warning'" [class.border-l-4]="border"
    [class.border-blue-500]="border && severity == 'info'" [class.border-green-500]="border && severity == 'success'"
    [class.border-red-500]="border && severity == 'error'" [class.border-yellow-500]="border && severity == 'warning'">

    <div class="flex flex-row">
        <span [class.text-yellow-500]="severity == 'warning'" [class.text-blue-500]="severity == 'info'"
            [class.text-green-500]="severity == 'success'" [class.text-red-500]="severity == 'error'">
            <svg fill="currentColor" viewBox="0 0 20 20" class="h-6 w-6 mt-3">
                <path fill-rule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"></path>
            </svg>
        </span>

        <div class="ml-4">
            <div #content>
                <ng-content></ng-content>
            </div>

            <div *ngIf="!content.innerHTML.trim()">
                <div>
                    <div class="text-lg" [class.text-blue-700]="severity == 'info'"
                        [class.text-green-700]="severity == 'success'" [class.text-red-700]="severity == 'error'"
                        [class.text-yellow-700]="severity == 'warning'">
                        {{title}}
                    </div>
                    <div class="text-sm" [class.text-blue-600]="severity == 'info'"
                        [class.text-green-600]="severity == 'success'" [class.text-red-600]="severity == 'error'"
                        [class.text-yellow-600]="severity == 'warning'">
                        {{text}}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="dismissible">
        <span class="cursor-pointer" [class.text-yellow-500]="severity == 'warning'" [class.text-blue-500]="severity == 'info'"
            [class.text-green-500]="severity == 'success'" [class.text-red-500]="severity == 'error'" (click)="triggerDismiss()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="h-6 w-6" fill="currentColor">
                <path fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd" />
            </svg>
        </span>
    </div>
</div>